import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import "../css/BecomeMemberDialog.css";
import { PROFILE_STATUS } from "utils/constants";
import ROUTE_PATHS from "utils/routePaths";
import { useNavigate } from "react-router-dom";

interface MembershipInviteOnlyDialogProps {
  profileStatus: string;
  open: boolean;
  onClose: () => void;
}

const MembershipInviteOnlyDialog: React.FC<MembershipInviteOnlyDialogProps> = ({
  profileStatus,
  open,
  onClose,
}) => {
  const navigate = useNavigate();

  const handleCTAClick = () => {
    if (profileStatus === PROFILE_STATUS.MEMBER) {
      navigate(ROUTE_PATHS.WSM_UR_MEMBERSHIP_PLAN_DETAIL);
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "become-member-dialog-container",
      }}
      BackdropProps={{
        className: "become-member-dialog-backdrop",
      }}
    >
      <DialogContent sx={{ padding: 0, margin: 0 }}>
        <div className="become-member-dialog-header">
          {profileStatus === PROFILE_STATUS.MEMBER
            ? "Reserved for the Inner Circle"
            : "Invite-Only Access"}
        </div>
        <div className="become-member-dialog-divider"></div>
        <div className="become-member-dialog-containt-container">
          <p>
            {profileStatus === PROFILE_STATUS.MEMBER
              ? "The Supreme Card is our most exclusive circle — curated and invite-only.Stay active, keep levelling up, and we’ll reach out when it’s time."
              : "Supreme Card is by invitation only You’re currently not eligible — but keep exploring The Foundry and show up strong. Your invite might just be around the corner."}
          </p>
        </div>
        <div className="become-member-dialog-button" onClick={handleCTAClick}>
          <div>
            {profileStatus === PROFILE_STATUS.MEMBER
              ? "View My Membership"
              : "Explore Other Memberships"}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MembershipInviteOnlyDialog;
